"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

exports.renderItemRoot = renderItemRoot;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _util = require("./util");

var _renderFromData = require("./render-from-data");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderItemRoot(item, props) {
    (0, _util.validateChildComponentType)(item);
    return _react2.default.cloneElement(item, {
        collapsed: props.collapsed,
        openKeys: props.openKeys,
        onOpen: props.onOpen,
        eventKey: item.key,
        opened: props.openKeysSet.has(item.key),
        openKeysSet: props.openKeysSet,
        level: 0,
        onSelectOps: props.onSelectOps,
        selectedKeysSet: props.selectedKeysSet,
        itemsChild: props.itemsChild,
        textIcon: (0, _util.propagateTextIconProp)(item.props.textIcon, props.textIcon),
        dataRenderCallback: (0, _util.propagateFunctionProp)(item.props.dataRenderCallback, props.dataRenderCallback),
        itemOnClick: (0, _util.propagateFunctionProp)(item.props.itemOnClick, props.itemOnClick)
    });
}

var Category = function (_React$Component) {
    (0, _inherits3.default)(Category, _React$Component);

    function Category(props) {
        (0, _classCallCheck3.default)(this, Category);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Category.__proto__ || (0, _getPrototypeOf2.default)(Category)).call(this, props));

        _this.renderDataChildren = _renderFromData.renderDataChildren.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Category, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                "div",
                { className: "cn-navfold-cat" },
                (0, _util.showIf)(!this.props.collapsed, function () {
                    return _react2.default.createElement(
                        "div",
                        { className: "cn-navfold-cat-title" },
                        _this2.props.title
                    );
                }),
                _react2.default.createElement(
                    "div",
                    { className: "cn-navfold-cat-child" },
                    _react2.default.Children.map(this.renderDataChildren(), function (n) {
                        return renderItemRoot(n, _this2.props);
                    }),
                    _react2.default.Children.map(this.props.children, function (n) {
                        return renderItemRoot(n, _this2.props);
                    })
                )
            );
        }
    }]);
    return Category;
}(_react2.default.Component);

Category.propTypes = {
    title: _propTypes2.default.string,
    openKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
    eventKey: _propTypes2.default.string,
    onOpen: _propTypes2.default.func,
    collapsed: _propTypes2.default.bool,

    openKeysSet: _propTypes2.default.object,
    onSelectOps: _propTypes2.default.func,
    selectedKeysSet: _propTypes2.default.object,
    itemsChild: _propTypes2.default.object,
    textIcon: _propTypes2.default.bool,

    dataSource: _propTypes2.default.arrayOf(_propTypes2.default.object),
    dataNode: _propTypes2.default.object,
    dataRenderCallback: _propTypes2.default.func,
    itemOnClick: _propTypes2.default.func
};
exports.default = Category;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-slider-bar-nav@0.0.38@@alicd/crui-slider-bar-nav/lib/Category.js
// module id = 109
// module chunks = 0